import FeatureFlags from "@/core/utilities/featureFlags";
import type { ModuleSettingsType } from "@/core/api/graphql/types";

export const BRL_CURRENCY_CODE = "BRL";
export const BRL_REPLACEMENT_CURRENCY_CODE = "USD";
export const DISABLE_BRL_CURRENCY_SETTING = "DisableBrlCurrency";

export const isBrlCurrencyDisabled = (modules: ModuleSettingsType[]): boolean =>
  new FeatureFlags(modules).isFeatureEnabled("Thorlabs.Commerce", DISABLE_BRL_CURRENCY_SETTING);
